<template>
  <div class="py-3">
    <page-title title="Content" />
    <hr />
    <filtered-table :settings="tableSettings" @rowClicked="onRowClicked">
    </filtered-table>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ContentBlockList",
  props: {},
  data() {
    let base = this;
    return {
      tableSettings: {
        endpoint: '/api/contentBlock',
        newUrl: '/contentBlock/add',
        columns: [
          {
            key: 'Id',
            name: 'ID',
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'slug',
            name: 'Slug',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'isPage',
            name: 'Is Page',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'title',
            name: 'Title',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'description',
            name: 'Description',
            visible: true,
            sortable: true,
            filter: 'text'
          }
        ],
        getDefaultFilter: function () {
          return '';
        }
      }
    }
  },
  methods: {
    onRowClicked: function (item, context) {
      this.$router.push('/contentBlock/' + item.id);
    }
  },
  mounted () {
  }
};
</script>